// extracted by mini-css-extract-plugin
module.exports = {"home":"LarissaHome_home__ccLII"};